function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2)",
  strokeMiterlimit: 8
}, React.createElement("rect", {
  className: "icon-secondary",
  x: 40.577,
  y: 13.248,
  width: 6.9109,
  height: 22.254,
  fill: "#adb9ca"
}), React.createElement("rect", {
  className: "icon-primary",
  x: 50.372,
  y: 19.815,
  width: 7.1248,
  height: 15.688,
  fill: "#ecaec6"
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(-2,1.0017)",
  stroke: "#002060"
}, React.createElement("rect", {
  className: "icon-tertiary",
  x: 22.56,
  y: 23.087,
  width: 6.8574,
  height: 11.413,
  fill: "#fff"
}), React.createElement("rect", {
  className: "icon-tertiary",
  x: 32.4,
  y: 18.646,
  width: 7.0784,
  height: 15.855,
  fill: "#fff"
}), React.createElement("rect", {
  x: 42.416,
  y: 12.496,
  width: 7.0713,
  height: 22.004,
  fill: "none"
}), React.createElement("rect", {
  x: 52.426,
  y: 18.521,
  width: 7.0713,
  height: 15.98,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2)",
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.3004 7.341c0-1.9989 1.6314-3.6194 3.6446-3.6194h17.008c2.0132 0 3.6446 1.6204 3.6446 3.6194v14.477c0 1.9989-1.6314 3.6194-3.6446 3.6194h-17.008c-2.0132 0-3.6446-1.6204-3.6446-3.6194z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m10.997 3.6627h17.022c2.0097 0 3.6377 1.5815 3.6377 3.5328v4.0506h-24.297v-4.0506c0-1.9514 1.6279-3.5328 3.6377-3.5328z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m10.938 3.7217h17.022c2.0097 0 3.6377 1.6122 3.6377 3.6015v4.1293h-24.297v-4.1293c0-1.9893 1.6279-3.6015 3.6377-3.6015z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m2.4999 4.2284c0-2.0258 1.6195-3.668 3.6181-3.668h16.884c1.9986 0 3.6181 1.6422 3.6181 3.668v14.672c0 2.0258-1.6195 3.668-3.6181 3.668h-16.884c-1.9986 0-3.6181-1.6422-3.6181-3.668z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m6.1375 0.56042h17.022c2.0097 0 3.6377 1.6535 3.6377 3.6935v4.2347h-24.297v-4.2347c0-2.0399 1.6279-3.6935 3.6377-3.6935z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.3593,
  y: 11.246,
  width: 3.1239,
  height: 2.2914,
  fill: "#adb9ca"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.5361,
  y: 16.408,
  width: 2.8882,
  height: 1.9238,
  fill: "#adb9ca"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2)",
  stroke: "#002060"
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.5997 3.9451c0-0.28118 0.21258-0.50926 0.47123-0.50926h15.001c0.25864 0 0.47123 0.22808 0.47123 0.50926v2.0378c0 0.28118-0.21258 0.50926-0.47123 0.50926h-15.001c-0.25864 0-0.47123-0.22808-0.47123-0.50926z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.111 0.56042h16.898c1.9951 0 3.6112 1.6535 3.6112 3.6935v4.2347h-24.121v-4.2347c0-2.0399 1.6161-3.6935 3.6112-3.6935z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(2.0026 -.049982)"
}, React.createElement("path", {
  d: "m11.952 12.519h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m11.952 17.504h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 5.5629,
  y: 11.502,
  width: 2.8293,
  height: 2.1006,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 5.5335,
  y: 16.546,
  width: 2.8882,
  height: 1.9238,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m41.671 14.683 0.55582-4.6131c-6.0274-1.193-8.5651-4.1724-5.6686-6.6545 2.8967-2.4822 10.13-3.5273 16.158-2.3344 6.0274 1.193 8.5651 4.1724 5.6694 6.6545-2.1396 1.8321-6.7638 2.9464-11.689 2.8164z",
  fill: "#fff",
  stroke: "#002060"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m45.647 5.5745c0-0.98626 0.81607-1.7858 1.8245-1.7858 1.0084 0 1.8245 0.79956 1.8245 1.7858 0 0.98626-0.81607 1.7858-1.8245 1.7858-1.0084 0-1.8245-0.79956-1.8245-1.7858z",
  fill: "#adb9ca"
}), React.createElement("g", {
  className: "icon-primary",
  transform: "matrix(.4105 0 0 .40177 35.155 -.032903)",
  fill: "#ecaec6",
  strokeWidth: 2.4624
}, React.createElement("path", {
  d: "m10.702 13.957c0-2.4548 1.99-4.4449 4.4446-4.4449 2.4567 0 4.4446 1.9901 4.4446 4.4449s-1.988 4.4449-4.4446 4.4449c-2.4546 0-4.4446-1.9901-4.4446-4.4449z"
}), React.createElement("path", {
  d: "m40.415 13.957c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.4105 0 0 .40177 35.155 .34589)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 2.4624
}, React.createElement("path", {
  d: "m10.584 13.014c0-2.4548 1.99-4.4449 4.4446-4.4449 2.4567 0 4.4446 1.9901 4.4446 4.4449s-1.988 4.4449-4.4446 4.4449c-2.4546 0-4.4446-1.9901-4.4446-4.4449z"
}), React.createElement("path", {
  d: "m25.558 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z"
}), React.createElement("path", {
  d: "m40.592 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z"
}));
var SvgMenuQuestionsTa = function SvgMenuQuestionsTa(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuQuestionsTa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-questions-ta.6f12faef.svg";
export { ForwardRef as ReactComponent };